import Layout from 'partials/layout'
import aboutImg from "../../assets/images/footerImg/aboutHero.svg"
import mutipleImg from "../../assets/images/footerImg/aboutMultiple.svg"
import { LuTarget } from "react-icons/lu";
import { PiCompassBold } from "react-icons/pi";
import { GrNotes } from "react-icons/gr";
import { FiCheckCircle, FiBookOpen, FiTool, FiVideo, FiHeart, FiUser, FiUsers } from "react-icons/fi";
import React from 'react'

export const AboutUs = () => {
  const coreFunctions = [
    "Organizing workshop and capacity building programmes",
    "Teachers' self-development programmes",
    "Organizing Annual Lagos State Festival of Instructional Materials (LASFIM)",
    "Monitoring of schools to ascertain the appropriate usage of Instructional Materials",
    "Evaluation of educational equipment and materials",
    "Hosting of excursions of schools (Public and Private) to the Centre",
    "Library services",
    "Educational consulting services",
    "Designing, distributing and sales of statutory records produced by the Centre to her final consumers",
    "Equipment management and maintenance in Schools",
    "Television and Radio lessons development",
    "Literature and educational films show demonstration",
    "Research on technological trends and development in education",
    "Access to Mobile laboratory for Teachers in riverine areas",
    "Teachers' lounge for discussion purposes",
  ];

  const history = [
    {
      id: 1,
      year: "Pre-2008",
      title: "Educational Technology Section",
      text: "The ERC did not start as a stand-alone entity. It was originally known as the Educational Technology Section and was closed for nearly five years before being restructured.",
    },
    {
      id: 2,
      year: "February 2008",
      title: "Conversion to Education Resource Centre",
      text: "The administration of Governor Babatunde Fashola approved its conversion into the Education Resource Centre, marking a shift from a focus solely on technology to a broader mission of providing comprehensive educational resources and teacher support.",
    },
    {
      id: 3,
      year: "September 2010",
      title: "Commissioning of the ERC building",
      text: "The centre was firmly established with the commissioning of a new building and ultra-modern equipment at its facility in Ojodu, Lagos. Then Deputy Governor, Princess Sarah Sosan, described it as a major investment aimed at tackling mass failures in examinations like the SSCE by improving the quality of teaching.",
    },
    {
      id: 4,
      year: "February 2021",
      title: "CASIO Maths and Science Teacher's Training Centre",
      text: "Launch of the CASIO Maths and Science Teacher's Training Centre at the ERC in partnership with SKLD Integrated Services, designed to train thousands of teachers to make subjects like mathematics more practical and engaging.",
    },
    {
      id: 5,
      year: "March 2024",
      title: "Listed under the Ministry of Basic and Secondary Education",
      text: "The ERC is officially listed as a key department under the Ministry of Basic and Secondary Education, with a vision to be a pro-active learning hub using cutting-edge technology to support lifelong learning.",
    },
    {
      id: 6,
      year: "June 2025",
      title: "Digital Teaching Hub",
      text: "Inauguration of a state-of-the-art Digital Teaching Hub within the ERC premises in Ojodu, launched in partnership with the tech company WALURE, supporting live and pre-recorded lessons, student-teacher interaction, and plans to expand into BECE, vocational and technical training content.",
    },
  ];

// TODO: these are AI-generated placeholder photos from the design mockup — swap for verified official photos before launch
const stateLeaders = [
  {
    id: 1,
    name: "Babajide Olusola Sanwo-Olu",
    role: "Governor of Lagos State",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuDprHSOrpytoT4ZO1LcdpDZY9JgddSTWCsgRzrp3dNilGT3cbLkLoAFBSIfYhlZHEBefHU4SHfAR2_odhFZbpvgC1UsZuFgF2p6yGmUt9gwNdQTeVcxs_YZj4KLIh-ZXnJbatYFcWjujVLVkGrA_RtEO9qv3c1V7ZYcb4oB_-7f2uvhMMwCPSQ8T7-lw2535AMfnXeUApYvNyD2fQnAka6LXdlRMQUKCc9Z90rGWmyDxB4QDxDKtrovhp40LECpHSZwhSiTCZwudbEv",
  },
  {
    id: 2,
    name: "Dr. Kadri Obafemi Hamzat",
    role: "Deputy Governor of Lagos State",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBi6D8VZ4x3s7mG_6_qQFua53NwRp1C37cF8Fj2WFhVpgK9Fbo2M2A-8erDKVP6Y1qs2b3b57-_Jc0x7Q6QUcC9zKJ9lXQ0rEGZxQbaI7J7EdbuqPhCWLA4iX-puSjbVk4oH0PQcXdir3XTIMetH-MRX-bYM3KE-WsW5lPM2K4dUX1M2oyNp2ZGe99TSdrSaP61kt81yH1ArwOd4u2x0uPLBe4BqsGnAvDtW2SIfAmzymUkZnOhM5GOLzOfIwIQDCQiSXjrDC8rLAq3",
  },
  {
    id: 3,
    name: "Mr. Jamiu Tolani Alli-Balogun",
    role: "Hon. Commissioner for Basic and Secondary Education",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuC2XEzDO9nD9beRkDHrbZ847ipBbm4KpWQaXGm80OadQo7ua3ZyEgShVXw0YP6bGQmWp1fZdZJkvVyHq3FJTKdq_4-C6r3BS3ZXFZbB8ldm2MaAD5Avt8b4qTLSv_XIgWxyKZBkU7nCpvbmiJ16JWoKTHj10dcBLtgQMrcx2bA-sfxLP26MdFAr7_Bq-lLBqLsXzsCE0cmOnbkO-ntXW8_tdT0NeYjPHlA1eZSaljgosyuSkIqGVFQvW9LZ3-kFbBYeTfK6-k8YGefV",
  },
  {
    id: 4,
    name: "Mr. Bode Agoro",
    role: "Lagos State Head of Service",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuA9OfVlj6-FduW8wsmXyGerxTCua9JmOT576avEQ66QCU7Jbl8G3EHp7rCnuWjZZV5IBgadPAn6kyE8RvnNke4bB1FiU2Nt7s5c8z11bTmGyovvLQa3iC9dU0I58YwUZ_x-TS4eGne2i2VHe6dVNGobCGemkeZsX-E5kq9qI7pIntF-FyCYPkaFs5Lt9CWenDHkaLeVToh0hcP0FmPpUwdffoyDsjXhoxiK2hk1XcEYRNbbVczFCjHyTMROeiI6ufhS4diBJ50bRP9d",
  },
  {
    id: 5,
    name: "Mrs. Abisola Dokunmu-Adegbite",
    role: "Permanent Secretary, Ministry of Basic and Secondary Education",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBOFgIA_fVTpqrBwzwAa2YN5GdneFhvertV3vc_2e5cc3ICOTi6ubmAAxw9MizuMoUOXM5imv4ZeB3VmsCNA1FLqVupQjf6syoleg4GVKJjjlu1am1977fhbyWstyUPzZTDPKZsRm7EFiTTsq0pyucatJFhmsQI9s7Djm_LAPpop3a8sYrcEMmKcdCHfaMzqEKCMKbre2krl2XnvBrGt7YbJWX1FqXe3Wf-AewSWzuLi-MJvPY56LPDj4l-5lfOUAIr62aEihScdPwo",
  },
];

  const departments = [
    { id: 1, icon: FiBookOpen, title: "E-Library", text: "Digital repositories and physical archives for comprehensive research." },
    { id: 2, icon: FiTool, title: "Vocational Workshops", text: "Practical skill development facilities for technical education." },
    { id: 3, icon: FiVideo, title: "Media Studios", text: "Recording and broadcasting facilities for remote learning content." },
    { id: 4, icon: FiHeart, title: "Wellness Portal", text: "Counselling and mental health support resources for students." },
  ];

  return (
    <Layout>
      {/* Hero */}
      <section className="lg:px-36 md:px-24 px-6 flex md:flex-row md:items-center flex-col bg-white gap-8 py-12">
        <div className="md:w-1/2 w-full flex flex-col gap-3">
          <h2 className='text-secondary text-[18px] font-ManropeBold leading-5'>ABOUT US</h2>
          <h1 className="md:text-[40px] text-[32px] md:leading-[50px] leading-[38px] text-black font-ManropeBold">
            Welcome to the Lagos State Education Resource Centre (ERC)
          </h1>
          <p className="text-[#6E7485] md:text-[18px] md:leading-[25px]">
            A pro-active learning hub providing excellent educational resources, state-of-the-art technology and innovative services in support of teaching and learning for the Education Sector of Lagos State.
          </p>
          {/* <div className="flex gap-4 pt-2">
            <button className="bg-secondary text-white px-6 py-3 rounded-lg font-ManropeBold text-sm hover:opacity-90 transition-opacity shadow-md">
              Our Initiatives
            </button>
            <button className="border border-secondary text-secondary px-6 py-3 rounded-lg font-ManropeBold text-sm hover:bg-secondary/5 transition-colors">
              Contact Us
            </button>
          </div> */}
        </div>

        <div className="md:w-1/2 w-full rounded-2xl overflow-hidden shadow-lg">
          <img src={aboutImg} alt="ERC building" className="object-cover w-full h-full" />
        </div>
      </section>

      {/* Vision / Mission */}
      <section className="bg-secondary py-16">
        <main className="lg:px-36 md:px-24 px-6 text-[#1D2026] md:flex-row flex flex-col md:gap-12 gap-6 md:items-center">
          <div className='md:w-1/2 w-full flex flex-col gap-6'>
            <div className="flex flex-col gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-6">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <PiCompassBold className="text-primary w-6 h-6" />
                </div>
                <h2 className="text-[22px] font-ManropeBold text-white">Our Vision</h2>
              </div>
              <p className="text-white/90 font-ManropeLight md:text-[16px] md:leading-6">
                To be a pro-active learning hub that will provide excellent educational resources, state-of-the-art technology and innovative services in support for teaching and learning for the Education Sector of Lagos State.
              </p>
            </div>
            <div className="flex flex-col gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-6">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <LuTarget className="text-primary w-6 h-6" />
                </div>
                <h2 className="text-[22px] font-ManropeBold text-white">Our Mission</h2>
              </div>
              <p className="text-white/90 font-ManropeLight md:text-[16px] md:leading-6">
                To constantly facilitate and enhance learning through the provision of quick and easy access to high quality cost effective educational resources, innovative education technology services and a better learning environment in support of lifelong learning and instruction.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 w-full rounded-2xl overflow-hidden">
            <img src={mutipleImg} alt="ERC resources" className="object-cover w-full h-full" />
          </div>
        </main>
      </section>

      {/* Mandate */}
      <section className="bg-white py-12 w-full">
        <main className="lg:px-36 md:px-24 px-6 text-[#1D2026] flex flex-col gap-6">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-secondary/10 flex items-center justify-center shrink-0">
              <GrNotes className="text-secondary w-6 h-6" />
            </div>
            <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary">Our Mandate</h1>
          </div>
          <p className="text-[#6E7485] md:text-[18px] md:leading-[28px]">
            The Lagos State Education Resource Centre is a Department of the Ministry of Basic and Secondary Education with the mandate to facilitate the realization of educational goals through the organization of trainings, workshops, conferences, and seminars on topical issues like the use of ICT in education, modern technological tools in education, and modern learning methods (e.g. Virtual Reality, Animations and Simulations, Blended Learning, Flipped Classroom). The Centre also delivers educational support services such as library services, Computer Based Test (CBT), an Educational Museum, excursions, a Subject Interactive Laboratory, a Teachers Resource Room, a Conference Room, Educational Radio & Television Broadcasts, and the design and production of media materials to cut across all levels of education in the State.
          </p>
        </main>
      </section>

      {/* Departments */}
      <section className="bg-[#F8F9FA] py-12 w-full">
        <main className="lg:px-36 md:px-24 px-6 flex flex-col gap-8">
          <div className="text-center flex flex-col gap-2">
            <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary">Our Departments</h1>
            <p className="text-[#6E7485] max-w-2xl mx-auto text-sm md:text-base">
              Specialized units working together to deliver comprehensive educational support.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {departments.map((dept) => {
              const Icon = dept.icon;
              return (
                <div
                  key={dept.id}
                  className="bg-white p-6 rounded-xl border border-gray-100 hover:shadow-lg transition-shadow group"
                >
                  <div className="w-12 h-12 bg-[#FEFEDE] rounded-lg flex items-center justify-center mb-4 group-hover:bg-secondary transition-colors">
                    <Icon className="text-secondary w-6 h-6 group-hover:text-white transition-colors" />
                  </div>
                  <h4 className="font-ManropeBold text-secondary mb-2">{dept.title}</h4>
                  <p className="text-[#6E7485] text-sm leading-5">{dept.text}</p>
                </div>
              );
            })}
          </div>
        </main>
      </section>

      {/* Core Functions */}
      <section className="bg-[#FEFEDE] py-12 w-full">
        <main className="lg:px-36 md:px-24 px-6 text-[#1D2026] w-full flex flex-col gap-8">
          <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary text-center">
            Core Functions
          </h1>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
            {coreFunctions.map((item, id) => (
              <div key={id} className="flex items-start gap-3 p-5 bg-white rounded-lg hover:shadow-md transition-shadow">
                <FiCheckCircle className="text-secondary w-6 h-6 shrink-0 mt-0.5" />
                <p className="text-[#4E5566] text-[14px] leading-5">{item}</p>
              </div>
            ))}
          </div>
        </main>
      </section>

      {/* History */}
      <section className="bg-white py-12 w-full">
        <main className="lg:px-36 md:px-24 px-6 flex flex-col gap-10">
          <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary text-center">
            Our History
          </h1>
          <div className="flex flex-col">
            {history.map((item, idx) => (
              <div key={item.id} className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-4 h-4 rounded-full bg-primary border-2 border-secondary shrink-0" />
                  {idx !== history.length - 1 && <div className="w-[2px] flex-1 bg-secondary/20" />}
                </div>
                <div className="pb-10">
                  <span className="text-secondary font-ManropeBold text-[14px]">{item.year}</span>
                  <h3 className="text-[#1D2026] font-ManropeSemibold text-[18px] leading-6 mt-1">{item.title}</h3>
                  <p className="text-[#6E7485] text-[14px] leading-6 mt-2">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </main>
      </section>

      {/* State Leadership & Stakeholders */}
      <section className="bg-white py-12 w-full border-t border-gray-100">
        <main className="lg:px-36 md:px-24 px-6 flex flex-col gap-8">
          <div className="text-center flex flex-col gap-2">
            <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary">
              State Leadership & Stakeholders
            </h1>
            <p className="text-[#6E7485] max-w-2xl mx-auto text-sm md:text-base">
              Dedicated leadership guiding the vision for educational excellence in Lagos State.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
            {stateLeaders.map((leader) => (
              <div className="flex flex-col group" key={leader.id}>
                <div className="relative w-full aspect-[3/4] mb-3 overflow-hidden rounded-lg bg-[#F3F4F5] shadow-sm border border-gray-100 flex items-center justify-center">
                  {leader.img ? (
                    <img
                      src={leader.img}
                      alt={leader.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <FiUser className="text-gray-300 w-12 h-12" />
                  )}
                </div>
                <h4 className="text-secondary font-ManropeSemibold text-sm leading-snug mb-1">{leader.name}</h4>
                <p className="text-[#6E7485] text-xs leading-5">{leader.role}</p>
              </div>
            ))}
          </div>
        </main>
      </section>

      {/* ERC Leadership & Team */}
<section className="bg-[#F8F9FA] py-12 w-full">
  <main className="lg:px-36 md:px-24 px-6 flex flex-col gap-8">
    <div className="text-center flex flex-col gap-2">
      <h1 className="md:text-[32px] text-[24px] font-ManropeBold text-secondary">ERC Leadership & Team</h1>
      <p className="text-[#6E7485] max-w-2xl mx-auto text-sm md:text-base">
        The dedicated team driving excellence at the Education Resource Centre.
      </p>
    </div>
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="flex flex-col lg:col-span-1">
        <div className="relative w-full aspect-[3/4] mb-4 overflow-hidden rounded-xl bg-white border border-gray-100 shadow-sm">
          {/* TODO: replace with real photo of the ERC Director */}
          <img
            src="https://picsum.photos/seed/erc-director/400/500"
            alt="Director, ERC"
            className="w-full h-full object-cover"
          />
        </div>
        <h4 className="font-ManropeSemibold text-secondary mb-1">Name of Director</h4>
        <p className="text-[#6E7485] text-sm">Director, ERC</p>
      </div>
      <div className="flex flex-col lg:col-span-2">
        <div className="relative w-full h-[240px] lg:h-auto lg:aspect-[2/1] mb-4 overflow-hidden rounded-xl bg-white border border-gray-100 shadow-sm">
          {/* TODO: replace with real team photo */}
          <img
            src="https://picsum.photos/seed/erc-team/800/400"
            alt="The ERC Team"
            className="w-full h-full object-cover"
          />
        </div>
        <h4 className="font-ManropeSemibold text-secondary mb-1">The ERC Team</h4>
        <p className="text-[#6E7485] text-sm">The passionate professionals supporting Lagos State's educational goals.</p>
      </div>
    </div>
  </main>
</section>
    </Layout>
  )
}